<ngx-smart-modal #oAuthDeviceModal 
[identifier]="modalType" 
[title]="modalTitle"
[closable]="false" 
[escapable]="false" 
[dismissible]="false" 
[showCloseButton]="oAuthShowCloseButton" 
[closeButtonText]="oAuthCloseButtonText"
[showConfirmButton]="oAuthShowConfirmButton" 
[confirmButtonText]="confirmButtonText">

    <div class="modal-content">
        <section *ngIf="response && deviceFlowState === DeviceFlowState.INITIAL" class="modal-header">
          <div class="container-fluid">
            <div class="row">
                <div class="col-xs-3 col-md-2">
                    <img alt="" [src]="response.LogoUrl" class="app-icon">
                </div>
                <div class="col-xs-9 col-md-10">
                    <h5>{{response.AppName}}</h5>
                    <h6>{{response.CompanyName}}</h6>
                </div>
            </div>    
          </div>
        </section>

        <section *ngIf="response && (deviceFlowState === DeviceFlowState.ERROR || deviceFlowState === DeviceFlowState.SUCCESS)" class="modal-header">
          <div class="container-fluid">
            <div class="row">
                <div class="col-xs-12 col-md-12">
                    <h3>OAuth Authorization</h3>
                </div>
            </div>    
          </div>
        </section>

        <hr *ngIf="response && deviceFlowState !== DeviceFlowState.SUCCESS" class="modal-separator">

        <section class="modal-body">
            <!-- Show permission request section only for INITIAL state -->
            <div *ngIf="response?.ScopeItems && deviceFlowState === DeviceFlowState.INITIAL">
                <p class="form-description" style="padding-left: 15px; padding-top: 0px;"><small>This app is requesting permission to:</small></p>
            
                <div class="gray-inset" style="margin: 0px 15px 0px 15px; max-height:180px; overflow-y:scroll; border: 1px solid #D3D3D3">
                    <ul style="list-style-type: none; padding-left: 15px; padding-right: 15px;">
                        <li>
                            <h6><span class="icomoon icon-one-person"></span> Access your basic information.</h6>
                            <p style="padding-left: 25px"><small>This includes your name and email address.</small></p>
                        </li>
                        <ng-container *ngFor="let scopeItem of response.ScopeItems">
                            <li><hr/></li>
                            <li>
                                <ng-container [ngSwitch]="scopeItem.Permission">
                                    <ng-container *ngSwitchCase="'GLOBALWRITE'">
                                        <h6><span class="icomoon icon-upload"></span> Global Write</h6>
                                        <p style="padding-left: 25px"><small>This app can update any of your projects, biosamples, libraries, pools, lanes, and app sessions, and can upload new data to your projects. You will own any new data that is created.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'CREATEPROJECT'">
                                        <h6><span class="icomoon icon-project"></span> Create Project</h6>
                                        <p style="padding-left: 25px"><small>This app may create Projects in your account.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'GLOBALBROWSE'">
                                        <h6><span class="icomoon icon-glasses"></span> Global Browse</h6>
                                        <p style="padding-left: 25px"><small>This app may browse the names of your Projects, Samples, and App Results, but cannot view or download the associated files.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'BROWSE'">
                                        <h6><span class="icomoon icon-glasses"></span> Browse</h6>
                                        <p style="padding-left: 25px">This app may view basic information about this project. It may not access files.</p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'WRITE'">
                                        <h6><span class="icomoon icon-upload"></span> Save data</h6>
                                        <p style="padding-left: 25px"><small>This app may upload new data or make changes to this project. You will own any new data that is created.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'CREATE'">
                                        <h6><span class="icomoon icon-upload"></span> Save data</h6>
                                        <p style="padding-left: 25px"><small>This app may upload new data to this project. You will own any new data that is created.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'READ'">
                                        <h6><span class="icomoon icon-glasses"></span> Read data</h6>
                                        <p style="padding-left: 25px"><small>This app may view and download the full contents of this project (including its Samples, App Results, and Files).</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'GLOBALREAD'">
                                        <h6><span class="icomoon icon-glasses"></span> Global Read</h6>
                                        <p style="padding-left: 25px"><small>This app may browse the names of your Projects, Samples, and App Results, and may view or download all associated Files.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'GLOBALCREATE'">
                                        <h6><span class="icomoon icon-upload"></span> Global Create</h6>
                                        <p style="padding-left: 25px"><small>This app may create child items (such as samples/appresults in a project) without access to see existing data.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'STARTAPPLICATIONS'">
                                        <h6><span class="icomoon icon-upload"></span> Start Applications</h6>
                                        <p style="padding-left: 25px"><small>This app may start other applications in your account.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'MANAGEAPPLICATIONS'">
                                        <h6><span class="icomoon icon-upload"></span> Manage Applications</h6>
                                        <p style="padding-left: 25px"><small>This app may create and modify applications that you own on your behalf.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'AUDIT_USER'">
                                        <h6><span class="icomoon icon-glasses"></span> Audit User</h6>
                                        <p style="padding-left: 25px"><small>This app may view a history of your activities in BaseSpace.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'AUDIT_DOMAIN'">
                                        <h6><span class="icomoon icon-glasses"></span> Audit Domain</h6>
                                        <p style="padding-left: 25px"><small>This app may view a history of all domain activities in BaseSpace.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'GLOBAL_MOVETOTRASH'">
                                        <h6><span class="icomoon icon-trash"></span> Global Move To Trash</h6>
                                        <p style="padding-left: 25px"><small>This app may send any of your Runs, Projects, App Results, and Samples to the trash, browse your trash, and restore any item from the trash.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'EMPTYTRASH'">
                                        <h6><span class="icomoon icon-trash"></span> Empty Trash</h6>
                                        <p style="padding-left: 25px"><small>This app may empty your trash at any time.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'CREATE_TOKEN'">
                                        <h6><span class="icomoon icon-key"></span> Create Workgroup Access Tokens</h6>
                                        <p style="padding-left: 25px"><small>This app can create tokens in order to view or place data in all your workgroups.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'CREATERUN'">
                                        <h6><span class="icomoon icon-key"></span> Create Run</h6>
                                        <p style="padding-left: 25px"><small>This app can upload a sequencing run folder to your account.</small></p>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault></ng-container>
                                </ng-container>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>

            <!-- Success State -->
            <div *ngIf="deviceFlowState === DeviceFlowState.SUCCESS" class="device-success-content">
                <div class="success-message-container">
                    <p class="success-message">Thanks! You may close this browser window</p>
                </div>
            </div>

            <!-- Error State -->
            <div *ngIf="deviceFlowState === DeviceFlowState.ERROR" class="device-error-content">
                <p class="form-description">Type the code provided by the application</p>
                <rad-text-field 
                    class="rad-theme--light"
                    label="Code"
                    [formControl]="deviceCodeControl"
                    placeholder="Enter code">
                </rad-text-field>
            </div>

            <div style="padding: 10px 15px 0px 15px; display: flex; flex-direction: column;">
                <rad-link
                *ngIf="response?.AgreementIdEula"
                class="rad-theme--light"
                target="_blank"
                [attr.href]="getAgreementUrl(response.AgreementIdEula)"
                >
                End User License Agreement
                </rad-link>

                <rad-link
                *ngIf="response?.AgreementIdPrivacy"
                class="rad-theme--light"
                target="_blank"
                [attr.href]="getAgreementUrl(response.AgreementIdPrivacy)"
                >
                Privacy Policy
                </rad-link>
            </div>

        </section>
        
    </div>

    <div class="error-container">
        <lib-error-alert-message
        [alertMsg]="alertMessages"
        [errorMsg]="errorMsg"
        ></lib-error-alert-message>
    </div>
    

</ngx-smart-modal>